import React from "react";
import { Form, Row, Col } from "antd";
import ControlledSelect from "../../components/Backoffice/ControlledSelectV1";
import ControlledRadio from "../../components/Backoffice/ControlledRadio";
import ControlledInput from "../../components/Backoffice/ControlledInput";
import ControlledDatePicker from "../../components/Backoffice/ControlledDatePicker";
import UploadDoc from "../../pages/authenticatedApp/backoffice/OrderListing/components/AddOrderComponents/UploadDoc";
import {
  DESTINATION_COUNTRIES,
  VARIANT_OPTIONS,
  SAMPLE_TYPES,
  SAMPLING_TYPES,
  QUANTITY_UNITS,
  REJECTION_REASONS,
} from "../../utils/constantData";
const CreateReplacementOrderForm = ({
  control,
  errors,
  options,
  orderStatus,
  permissions,
  watch,
  setValue,
  orderDetails,
}) => {
  const {
    commodities = [],
    states = [],
    districts = [],
    samplers = [],
    projectCodes = [],
    companies = [],
    sectors = [],
    agencies = [],
    packages = [],
  } = options;

  const projectConfig = orderDetails?.projectCodeId?.projectConfig || {};
  const requiredDocs = projectConfig?.projectDocuments || [];
  const requiredFields = projectConfig?.metadataFields || [];

  const dataMapOptions = [
    {
      label: "Map Available Data",
      value: "mapAvailableData",
      disabled: permissions?.mapPreviousDetails === false,
    },
    {
      label: "Create Fresh Order",
      value: "createFreshOrder",
      disabled: permissions?.createFreshOrder === false,
    },
  ];

  return (
    <Form>
      <>
        <Row gutter={24}>
          <Col span={24}>
            <ControlledRadio
              required
              control={control}
              name="dataMap"
              label="Data Map"
              options={dataMapOptions}
              errors={errors}
            />
          </Col>
          <Col span={24}>
            <ControlledSelect
              required
              control={control}
              name="replacementReason"
              label="Replacement Reason"
              options={REJECTION_REASONS}
              errors={errors}
            />
          </Col>
        </Row>

        <Row gutter={[16, 0]}>
          {/* Client */}
          <Col span={12}>
            <ControlledSelect
              required
              control={control}
              name="company"
              label="Client"
              options={companies}
              errors={errors}
              disabled={true}
            />
          </Col>
          {/* Project Code */}
          <Col span={12}>
            <ControlledSelect
              required
              control={control}
              name="projectCode"
              label="Project Code"
              options={projectCodes}
              errors={errors}
              disabled={true}
            />
          </Col>
          {/* Agency */}
          {requiredFields?.agency?.required && (
            <Col span={12}>
              <ControlledSelect
                required={requiredFields?.agency?.mandatory}
                control={control}
                name="agency"
                label="Agency"
                options={agencies}
                errors={errors}
                 customChange={() => {
                  setValue("sampler", ""); 
                }}
              />
            </Col>
          )}
          {/* Commodity */}
          {requiredFields?.commodity?.required && (
            <Col span={12}>
              <ControlledSelect
                required={requiredFields?.commodity?.mandatory}
                control={control}
                name="commodity"
                label="Commodity"
                options={commodities}
                errors={errors}
                customChange={() => {
                  setValue("package", "");
                }}
              />
            </Col>
          )}
          {/* Sample Variant */}
          {requiredFields?.variant?.required && (
            <Col span={12}>
              <ControlledSelect
                required={requiredFields?.variant?.mandatory}
                control={control}
                name="sampleVariant"
                label="Sample Variant"
                options={VARIANT_OPTIONS}
                errors={errors}
                customChange={() => {
                  setValue("package", "");
                }}
              />
            </Col>
          )}
          {requiredFields?.sampleType?.required && (
            <Col span={12}>
              <ControlledSelect
                required={requiredFields?.sampleType?.mandatory}
                control={control}
                name="sampleType"
                label="Sample Type"
                options={SAMPLE_TYPES}
                errors={errors}
              />
            </Col>
          )}
          <Col span={12}>
            <ControlledSelect
              required
              control={control}
              name="package"
              label="Package"
              options={packages}
              errors={errors}
            />
          </Col>
          {/* Sector */}
          {requiredFields?.sector?.required && (
            <Col span={12}>
              <ControlledSelect
                required={requiredFields?.sector?.mandatory}
                control={control}
                name="sector"
                label="Sector"
                options={sectors}
                errors={errors}
              />
            </Col>
          )}
          {requiredFields?.state?.required && (
            <Col span={12}>
              <ControlledSelect
                required={requiredFields?.state?.mandatory}
                control={control}
                name="state"
                label="State"
                options={states}
                errors={errors}
              />
            </Col>
          )}
          {/* District */}
          {requiredFields?.district?.required && (
            <Col span={12}>
              <ControlledSelect
                required={requiredFields?.district?.mandatory}
                control={control}
                name="district"
                label="District"
                options={districts}
                errors={errors}
              />
            </Col>
          )}
          {requiredFields?.destinationCountry?.required && (
            <Col span={12}>
              <ControlledSelect
                required={requiredFields?.destinationCountry?.mandatory}
                control={control}
                name="destinationCountry"
                label="Destination Country"
                options={DESTINATION_COUNTRIES}
                errors={errors}
              />
            </Col>
          )}
          {/* Sampling Type */}
          {requiredFields?.samplingType?.required && (
            <Col span={12}>
              <ControlledSelect
                required={requiredFields?.samplingType?.mandatory}
                control={control}
                name="samplingType"
                label="Sampling Type"
                options={SAMPLING_TYPES}
                errors={errors}
                customChange={() => {
                  setValue("codewiseReason", "");
                }}
              />
            </Col>
          )}
          {requiredFields?.codewiseReason?.required &&
            watch("samplingType") === "Code-wise Sampling" && (
              <Col span={12}>
                <ControlledInput
                  required={requiredFields?.codewiseReason?.mandatory}
                  control={control}
                  name="codewiseReason"
                  label="Code-wise Reason"
                  errors={errors}
                />
              </Col>
            )}
          {/* Expected Consignment Readiness */}
          {requiredFields?.expectedConsignmentReadiness?.required && (
            <Col span={12}>
              <ControlledDatePicker
                required={requiredFields?.expectedConsignmentReadiness?.mandatory}
                control={control}
                name="expectedConsignmentReadiness"
                label="Expected Consignment"
                errors={errors}
              />
            </Col>
          )}
          {requiredFields?.expectedShipmentDate?.required && (
            <Col span={12}>
              <ControlledDatePicker
                required={requiredFields?.expectedShipmentDate?.mandatory}
                control={control}
                name="expectedShipmentDate"
                label="Expected Shipment Date"
                errors={errors}
              />
            </Col>
          )}
          {/* Sampler */}
          {requiredFields?.sampler?.required && (
            <Col span={12}>
              <ControlledSelect
                required={requiredFields?.sampler?.mandatory}
                control={control}
                name="sampler"
                label="Sampler"
                options={samplers}
                errors={errors}
              />
            </Col>
          )}
          {requiredFields?.siteAddress?.required && (
            <Col span={12}>
              <ControlledInput
                required={requiredFields?.siteAddress?.mandatory}
                control={control}
                name="siteAddress"
                label="Site Address"
                errors={errors}
              />
            </Col>
          )}
          {/* Batch ID */}
          {requiredFields?.batchId?.required && (
            <Col span={12}>
              <ControlledInput
                required={requiredFields?.batchId?.mandatory}
                control={control}
                name="batchId"
                label="Batch ID"
                errors={errors}
              />
            </Col>
          )}
          {/* Supplier */}
          {requiredFields?.supplier?.required && (
            <Col span={12}>
              <ControlledInput
                required={requiredFields?.supplier?.mandatory}
                control={control}
                name="supplier"
                label="Supplier"
                errors={errors}
              />
            </Col>
          )}
          {requiredFields?.quantity?.required && (
            <Col span={12}>
              <ControlledInput
                required={requiredFields?.quantity?.mandatory}
                type="number"
                control={control}
                name="quantity"
                label="Quantity"
                errors={errors}
              />
            </Col>
          )}
          {/* Quantity Unit */}
          {requiredFields?.quantityUnit?.required && (
            <Col span={12}>
              <ControlledSelect
                required={requiredFields?.quantityUnit?.mandatory}
                control={control}
                name="quantityUnit"
                label="Quantity Unit"
                options={QUANTITY_UNITS}
                errors={errors}
              />
            </Col>
          )}
          {requiredFields?.notes?.required && (
            <Col span={12}>
              <ControlledInput
                required={requiredFields?.notes?.mandatory}
                control={control}
                name="additionalNotes"
                label="Additional Notes"
                errors={errors}
                textarea
              />
            </Col>
          )}
        </Row>
        <Row>
          {requiredDocs.length > 0 && (
            <Col span={24} style={{ marginTop: 16 }}>
              <Form.Item
                // label="Required Documents"
                validateStatus={errors?.documents ? "error" : ""}
                help={errors?.documents?.message}
              >
                <UploadDoc
                  documents={requiredDocs}
                  value={watch("documents") || []}
                  onChange={(updater) =>
                    setValue("documents", updater(watch("documents") || []), {
                      shouldValidate: true,
                    })
                  }
                />
              </Form.Item>
            </Col>
          )}
        </Row>
      </>
    </Form>
  );
};

export default CreateReplacementOrderForm;
